import { TApiUsersAccount } from "./api-client/types"

export const getUsersAccountFullName = (usersAccount: { 
  firstName: string,
  lastName: string,
}) => {
  return `${usersAccount.firstName} ${usersAccount.lastName}`
}